import { ServiceEntryFileDescriptor } from './service-entry-form-state';

/**
 * Validates file attachments for service entries.
 * Returns true if validation fails (files are invalid).
 *
 * @param files - Array of file descriptors to validate
 * @param maxSizeMB - Maximum file size in megabytes (default: 5MB)
 * @param maxFiles - Maximum number of files allowed (default: 5)
 * @returns true if validation fails, false if valid
 */
export const validateFiles = (
    files: ServiceEntryFileDescriptor[],
    maxSizeMB = 5,
    maxFiles = 5
): boolean => {
    return (
        files.length > maxFiles ||
        files.some(file => file.file instanceof File && file.file.size > maxSizeMB * 1024 * 1024)
    );
};
